import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    beneficiaryFaqLink: 'Learn more about beneficial owners',
    description: {
      capDep:
        'We are legally obliged to ask you for information about the people who have a key role in your company:',
      standard:
        'A beneficial owner is an individual who owns more than 25% of the capital or voting rights, or any power of control over the company.',
    },
    title: {
      capDep: 'Add your company’s key individuals',
      standard: 'Add your beneficial owners',
    },
  },
  fr: {
    beneficiaryFaqLink: 'En savoir plus à propos des bénéficiaires effectifs',
    description: {
      capDep:
        'Nous sommes tenus légalement de vous demander certaines informations à propos des personnes qui ont un rôle clé au sein de votre entreprise\u00A0:',
      standard:
        'Un bénéficiaire effectif est une personne physique qui possède plus de 25\u00A0% du capital ou des droits de vote, ou tout pouvoir de contrôle sur l’entreprise.',
    },
    title: {
      capDep: 'Ajouter les personnes clés de votre entreprise',
      standard: 'Bénéficiaires effectifs',
    },
  },
});
